//Agency---------------------------------
export const USER_BASE_PATH = '/';
export const LANDING_PATH = '/landingpage';
export const SIGNIN_PATH = '/signin';
export const DASHBOARD_PATH = '/dashboard';
export const REQUESTS_PATH = '/requests';
export const USERS_ROUTE_PATH = '/users';
export const CUSTOMERS_ROUTE_PATH = '/customers';
export const VIEW_CUSTOMER_PATH = '/customerdetails';
export const VIEW_USER_PATH = '/viewUser';
export const DOCUMENTS_PATH = '/documents';
export const DOCUMENT_VIEW_PATH = '/view-document/:id';
export const DOCUMENT_PREVIEW_PATH = '/preview-document/:hyperlink';
export const DOCUMENT_EDIT_PATH = '/edit-document/:id';
export const PAYMENTS_PATH = '/payments';
export const PROFILE_PATH = '/profile';
export const AGENCY_PROFILE_PATH = '/agency-profile';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const UPLOADDOCUMENT_PATH = '/create-document';
export const PASSWORDUPDATE_PATH = '/password-update';
//-------------------------------------

//Admin-------------------------------
export const ADMIN_PATH = '/admin';
export const ADMIN_DASHBOARD_PATH = '/admin/dashboard';
export const ADMIN_USERS_PATH = '/admin/admins';
export const ADMIN_AGENCIES_PATH = '/admin/agencies';
export const ADMIN_AGENCYDETAILS_PATH = '/admin/agency';
export const ADMIN_DOCUMENTS_PATH = '/admin/documents';
export const ADMIN_REQUESTS_PATH = '/admin/requests';
export const ADMIN_PAYMENTS_PATH = '/admin/payments';
export const ADMIN_PROFILE_PATH = '/admin/profile';
export const ADMIN_SERVICE_REQUESTS_PATH = '/admin/serviceRequests';
export const AGENCY_INSTRUCTIONS_PAGE = '/admin/instructions';
//--------------------------------------

//Invoice
export const AGENCY_INVOICE_PAGE = '/invoice';
export const AGENCY_NEWINVOICE_PAGE = '/new-invoice';
export const AGENCY_VIEW_INVOICE = '/view-invoice/:id';

export const AGENCY_SUBSCRIPTIONS_PAGE = '/subscriptions';
export const AGENCY_SUBSCRIPTIONS_NEW_PAGE = '/subscriptions/new';
export const AGENCY_SUBSCRIPTIONS_EDIT_PAGE = '/subscriptions/edit';

export const AGENCY_CUSTOMER_PAGE = '/customer';
export const AGENCY_CUSTOMER_NEW_PAGE = '/customer/new';
export const AGENCY_CUSTOMER_EDIT_PAGE = '/customer/edit';

//Coupons
export const AGENCY_COUPONS_PAGE = '/coupons';
export const AGENCY_COUPONS_NEW_PAGE = '/coupons/new';
export const AGENCY_COUPONS_EDIT_PAGE = '/coupons/edit';

//Web Form Report
export const AGENCY_REPORT_PAGE = '/report';

//Common---------------------------------
export const PAGE_NOT_FOUND_PATH = '*';
//--------------------------------------

//End User ---------------------------------
export const END_USER_LANDING_PATH = '/s/:documentURL';
//--------------------------------------

//INVOICE PAYMET PAGE
export const PAYMENT_PAGE = '/invoicepayment';

//Webform User Reports
export const WEBFORM_USER_REPORT = '/report/webform/:id';
